import {
    Tooltip,
    TooltipGlobalStyle,
    WorthyThemeProvider,
} from "@worthy-npm/worthy-ui-components";
import { imageUrl } from "helpers/ApplicationHelper";
import React from "react";

const GiaTooltip = () => {
    const isMobile = window.innerWidth < 568;

    return (
        <WorthyThemeProvider>
            <TooltipGlobalStyle />
            <Tooltip
                placement={isMobile ? "topLeft" : "top"}
                trigger={isMobile ? "click" : "hover"}
                align={{ offset: isMobile ? [-30, 0] : [0, 0] }}
                content={
                    <div style={{ maxWidth: 245, padding: "0 2px" }}>
                        If you have a report from GIA (Gemological Institute of
                        America), click below to enter your report number. If
                        you have a report from another grading lab, upload your
                        report as an image above.
                    </div>
                }
            >
                <img
                    src={imageUrl("common/question.svg")}
                    alt="Report details help"
                />
            </Tooltip>
        </WorthyThemeProvider>
    );
};

export default GiaTooltip;
